function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputfieldError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.372549%,11.372549%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 45.78125 27.050781 C 45.925781 26.054688 46 25.035156 46 24 C 46 22.941406 45.921875 21.902344 45.773438 20.886719 C 44.261719 10.210938 35.09375 2 24 2 C 11.847656 2 2 11.847656 2 24 C 2 35.09375 10.210938 44.261719 20.886719 45.777344 C 21.902344 45.921875 22.941406 46 24 46 C 25.039062 46 26.058594 45.925781 27.058594 45.78125 C 36.761719 44.433594 44.4375 36.757812 45.78125 27.050781 Z M 45.78125 27.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.027344 30.226562 C 22.664062 30.226562 21.5625 31.328125 21.5625 32.691406 C 21.5625 34.050781 22.664062 35.15625 24.027344 35.15625 C 25.386719 35.15625 26.492188 34.050781 26.492188 32.691406 C 26.492188 31.328125 25.386719 30.226562 24.027344 30.226562 Z M 24.027344 30.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.414062 12.917969 C 22.238281 13.273438 21.453125 14.382812 21.511719 15.609375 C 21.570312 16.394531 21.617188 17.179688 21.679688 17.957031 C 21.847656 20.925781 22.011719 23.835938 22.183594 26.800781 C 22.222656 27.785156 23.042969 28.554688 24.027344 28.53125 C 25.027344 28.53125 25.84375 27.738281 25.871094 26.738281 C 25.871094 26.125 25.871094 25.5625 25.929688 24.941406 C 26.039062 23.039062 26.15625 21.136719 26.265625 19.230469 C 26.324219 18 26.433594 16.765625 26.492188 15.53125 C 26.503906 15.109375 26.425781 14.691406 26.265625 14.300781 C 25.773438 13.210938 24.574219 12.628906 23.414062 12.917969 Z M 23.414062 12.917969 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputfieldError);
export default __webpack_public_path__ + "static/media/inputfield_error.7b2e7f60e2b3280e0069cb2d7169f3e9.svg";
export { ForwardRef as ReactComponent };